import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import Multiselect from "multiselect-react-dropdown";
import Dropdown from "../../FormElements/Dropdown";
import Input from "../../FormElements/Input";
import Error from "../../Layout/Error";
import { globalNationalitiesDropList } from "../../../services/GlobalNationalitiesList";
import { globalEthnicityList } from "../../../services/GlobalEthnicityList";
import { globalLanguagesSpokenList } from "../../../services/GlobalLanguagesSpokenList";
const PersonalInfoFields = (props) => {
  const [userdata, setFormdata] = useState({});
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const { errors } = props;

  const parseLanguageValues = (raw) => {
    if (!raw) return [];
    if (Array.isArray(raw)) return raw;
    if (typeof raw === "string") {
      const trimmed = raw.trim();
      if (!trimmed) return [];
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) return parsed;
      } catch (err) {
        return trimmed
          .split(",")
          .map((item) => item.trim())
          .filter((item) => item);
      }
    }
    return [];
  };

  useEffect(() => {
    setFormdata(props.data);
  }, [props.data]);

  useEffect(() => {
    const values = parseLanguageValues(userdata.cnd_languages);
    const selected = values
      .map((value) =>
        globalLanguagesSpokenList.find((option) => option.value === value)
      )
      .filter(Boolean);
    setSelectedLanguages(selected);
  }, [userdata.cnd_languages]);

  const handleLanguagesChange = (selectedList) => {
    setSelectedLanguages(selectedList);
    props.onChange({
      target: {
        name: "cnd_languages",
        value: selectedList.map((item) => item.value),
      },
    });
  };

  return (
    <React.Fragment>
      <Input
        type="text"
        label="First Name"
        placeholder={"Eg., John"}
        changeHandler={(e) => props.onChange(e)}
        name="users_firstname"
        id={"users_firstname"}
        disabled={userdata.users_firstname ? true : false}
        value={userdata.users_firstname}
        errors={errors}
      />
      <Input
        type="text"
        label="Last Name"
        placeholder={"Eg., Doe"}
        changeHandler={(e) => props.onChange(e)}
        name="users_lastname"
        id={"users_lastname"}
        disabled={userdata.users_lastname ? true : false}
        value={userdata.users_lastname}
        errors={errors}
      />
      <Input
        type="email"
        label="Email"
        placeholder={"Eg. johndoe@example.com"}
        disabled={"disabled"}
        changeHandler={(e) => props.onChange(e)}
        name="users_email"
        id={"users_email"}
        value={userdata.users_email}
        errors={errors}
      />
      <Dropdown
        name="cnd_gender"
        id={"cnd_gender"}
        value={userdata.cnd_gender}
        label="Select Gender"
        options={[
          {
            name: "Select Gender",
            value: "",
          },
          {
            name: "Male",
            value: "male",
          },
          {
            name: "Female",
            value: "female",
          },
          {
            name: "Other",
            value: "other",
          },
        ]}
        changeHandler={(e) => props.onChange(e)}
        errors={errors}
      />
      {/* {JSON.stringify(userdata, null, 2)} */}
      <Input
        type="date"
        label="Date of Birth"
        placeholder={"Eg., 01/01/1990"}
        name="cnd_birth_date"
        id={"cnd_birth_date"}
        disabled={((userdata.cnd_status === "Submitted" || userdata.cnd_status === "Approved") && userdata.user_sign_signature) ? true : false}
        min={
          new Date(new Date().setFullYear(new Date().getFullYear() - 100))
            .toISOString()
            .split("T")[0]
        }
        max={
          new Date(new Date().setFullYear(new Date().getFullYear() - 15))
            .toISOString()
            .split("T")[0]
        }
        defaultValue={userdata.cnd_birth_date}
        value={userdata.cnd_birth_date}
        changeHandler={(e) => props.onChange(e)}
        errors={errors}
        lg={4}
      />
      <Input
        type="text"
        label="Phone Number"
        placeholder={"Eg., 01234567890"}
        changeHandler={(e) => props.onChange(e)}
        disabled={userdata.users_phonenumber ? true : false}
        name="users_phonenumber"
        id={"users_phonenumber"}
        value={userdata.users_phonenumber}
        errors={errors}
        lg={4}
      />
      <Dropdown
        name="cnd_nationality"
        id={"cnd_nationality"}
        value={userdata.cnd_nationality}
        label="Nationality"
        options={globalNationalitiesDropList}
        changeHandler={(e) => props.onChange(e)}
        errors={errors}
        lg={4}
      />
       {/* Code written by Divya Added cnd_ethnicity and cnd_languages fields  */}
    <Dropdown
      name="cnd_ethnicity"
      id="cnd_ethnicity"
      value={userdata.cnd_ethnicity}
      label="Ethnicity"
      options={globalEthnicityList}
      changeHandler={(e) => props.onChange(e)}
      errors={errors}
       required={true}
      />

     <div className="col-lg-6 col-md-6">
     <div className="form-group">
     <label> Languages Spoken <span style={{ color: "red" }}>*</span></label>

    <Multiselect
      name="cnd_languages"
      options={globalLanguagesSpokenList.filter((o) => o.value)}
      selectedValues={globalLanguagesSpokenList.filter((option) =>
        (userdata.cnd_languages || []).includes(option.value)
      )}
      onSelect={(selectedList) => {
        props.onChange({
          target: {
            name: "cnd_languages",
            value: selectedList.map((item) => item.value),
          },
        });
      }}
      onRemove={(selectedList) => {
        props.onChange({
          target: {
            name: "cnd_languages",
            value: selectedList.map((item) => item.value),
          },
        });
      }}
      displayValue="name"
      
    />
    <Error errors={errors} fieldName={"cnd_languages"} />
  </div>
</div>
      <Input
        type="text"
        label="Home Telephone"
        placeholder={"Eg., 012345678"}
        changeHandler={(e) => props.onChange(e)}
        name="cnd_home_mobile_number"
        id={"cnd_home_mobile_number"}
        value={userdata.cnd_home_mobile_number}
        errors={errors}
        req={false}
      />
      <Input
        type="text"
        label="Next of Kin First Name"
        placeholder={"Eg., Jane"}
        changeHandler={(e) => props.onChange(e)}
        name="cnd_kin_firstname"
        id={"cnd_kin_firstname"}
        value={userdata.cnd_kin_firstname}
        errors={errors}
      />
      <Input
        type="text"
        label="Next of Kin Last Name"
        placeholder={"Eg., Doe"}
        changeHandler={(e) => props.onChange(e)}
        name="cnd_kin_lastname"
        id={"cnd_kin_lastname"}
        value={userdata.cnd_kin_lastname}
        errors={errors}
      />
      <Input
        type="text"
        label="Next of Kin Phone Number"
        placeholder={"Eg., 01234567890"}
        changeHandler={(e) => props.onChange(e)}
        id={"cnd_kin_phonenumber"}
        name="cnd_kin_phonenumber"
        value={userdata.cnd_kin_phonenumber}
        errors={errors}
      />
    </React.Fragment>
  );
};

export default PersonalInfoFields;
